import React from "react";
import style from './Modal.styl'



const ModalPopup = ({setActive,warningText,type}) => {
	let background={backgroundColor: '#FFCC3F'}
	if(type){
		if(type==='itk'){
			background={backgroundColor: '#76d750'}
		}
	}
  return(
		<div className={style.modal}>
			<div className={style.modalContent}>
				<div className={style.popupHeader} style={background}>
					<span>Предупреждение</span>
					<div
						className={style.symbol}
						onClick={() =>setActive(false)}>
						&#10006;
					</div>
				</div>
				<div className={style.content}>
					{warningText}
				</div>
			</div>
		</div>
	)
}
export default ModalPopup



// WEBPACK FOOTER //
// ./src/react/ui/features/Modal/Modal.jsx